module.exports = __webpack_public_path__ + "static/media/Map4.cb9b84e1.jpg";